module.exports = __webpack_public_path__ + "static/media/back-white.fb7f3c6e.svg";